// Phones: novices start on a budget Andro, KOLs on an iFone. Upgrade at Plug Gadgets.
// The phone you carry changes the in-game phone UI (Andro vs iFone style). Purely a status item.

import { TUNABLES } from "@degen/shared/config/tunables";
import { money } from "@degen/shared/money";
import { pushLog, type GameState } from "../state";

export type PhoneOs = "andro" | "ifone";

export interface PhoneModel {
  id: string;
  name: string;
  os: PhoneOs;
  price: number;
  tagline: string;
  color: string;
}

export const PHONES: PhoneModel[] = [
  { id: "andro_a15", name: "Andro A15", os: "andro", price: 0, tagline: "It calls, it trades, the battery is a suggestion.", color: "#3b82f6" },
  { id: "andro_ultra", name: "Andro S Ultra", os: "andro", price: 1_200, tagline: "Stylus included. Zoom on charts like a pro.", color: "#111827" },
  { id: "ifone_16", name: "iFone 16", os: "ifone", price: 1_800, tagline: "The green-bubble era is over.", color: "#e5e7eb" },
  { id: "ifone_17pro", name: "iFone 17 Pro Max", os: "ifone", price: 4_500, tagline: "Titanium. For screenshots of your PnL.", color: "#c2a477" },
];

export const phoneModel = (id: string) => PHONES.find((p) => p.id === id) ?? PHONES[0];

export const starterPhone = (kol: boolean) => (kol ? "ifone_16" : "andro_a15");

type Result = { ok: true; data?: Record<string, number> } | { ok: false; error: string };

export function buyPhone(state: GameState, id: string): Result {
  const m = PHONES.find((x) => x.id === id);
  const p = state.player;
  if (!m) return { ok: false, error: "Unknown phone." };
  if (p.phones.includes(id)) return { ok: false, error: "You already have that one." };
  if (p.cash < m.price) return { ok: false, error: `The ${m.name} costs ${money(m.price)}.` };
  p.cash -= m.price;
  p.phones.push(id);
  p.phone = id;
  const flex = Math.min(TUNABLES.phones.flexCap, Math.round(p.followers * TUNABLES.phones.flexFollowers));
  p.followers += flex;
  pushLog(state, "phone_bought", `📱 New phone: ${m.name}. Unboxing post did numbers (+${flex} followers).`);
  return { ok: true, data: { followers: flex } };
}

export function setPhone(state: GameState, id: string): Result {
  if (!state.player.phones.includes(id)) return { ok: false, error: "You don't own that phone." };
  state.player.phone = id;
  return { ok: true };
}
